export default {
	subscriptions: {
		activeSubscription: 'Aktiviertes Abo: ',
		features: 'Bestandteile',
		description: {
			basic: 'Die Basisversion',
			full: 'Die vollumfängliche Version',
		},
		property_manager: 'Hausverwalter',
		person_update_requests: 'Personenbezogene Datenänderung',
		user_normal: 'Endkunden',
		notification_welcome: 'Benachrichtigung zur Anmeldung',
		notification_lost_password: 'Passwortänderung',
		notification_damage_report: 'Schadensmeldung',
		notification_message: 'Nachrichten',
		notification_note: 'Benachrichtigung zu Notizen',
		notification_meter: 'Benachrichtigung zu Zählern',
		notification_document: 'Benachrichtigung zu Dokumenten',
		notification_handover: 'Benachrichtigung zu Übergabeprotokollen',
		notification_person_update:
			'Benachrichtigung zu Personenbezogene Änderungen',
		notification_tos: 'Benachrichtigung zu TOS',
		notification_ticket_history: 'Benachrichtigung zu Tickets ',
		notification_consumption: 'Benachrichtigungen zum Verbrauch',
		notification_review_document: 'Benachrichtigungen zu Belegprüfungen',
		notification_report: 'Benachrichtigungen zu Meldungen',
		external_track_lean: 'Track Lean',
		external_inbound_mail: 'Eingehende Emails',
	},
}
